<template>
    <footer class="bg_black">
        <div class="wrap d_f jc_sb ai_c">
            <div class="adder c_white">
                <p class="c_white">
                     <span class="d_b P_xs" style="margin-bottom:10rpx">联系电话：</span>
                     <span class="d_b P_ml">{{about.telephoto}}</span>
                </p>
                <p class="P_xs">
                    <span class="d_b">公司地址：{{about.address}}</span>
                </p>
            </div>
            <!--<div class="share">
                <img src="../../assets/ewm.png" alt="" class="d_b w_1">
                <p class='c_white'>扫描关注</p>
            </div> -->
        </div>
    </footer>
</template>

<script>
import index from './index'
export default {
    ...index
}
</script>

<style lang="scss" scoped>


    footer{
        height: 370px;
        .wrap{
            width: 1200px;
            margin: auto;
            height: 100%;

            .share{
                width: 134px;
                p{
                    margin:25px 0 0;
                    text-align: center;
                    font-size: 26px;
                }
            }
        }
    }



</style>